// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"70d62bc8","133":"dcdd0957","191":"70d62bc8","276":"70d62bc8","319":"0961ba60","347":"6887b221","381":"70d62bc8","625":"97eaff80","724":"70d62bc8","738":"96d019c9","761":"275bb640","955":"c1dc5be0","964":"48899dfe"}[chunkId] + ".chunk.css";
};